import { DataBean } from "../DataBean";

export class FixedAssetItemDepreciation extends DataBean {


    public async getFixedAssetItemDepreciationCatalog(idItem:any,boolean:any,processType:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetItemDepreciationCatalog_Number_boolean_Number", [idItem,boolean,processType]);
    }
}